// extracted by mini-css-extract-plugin
export var container = "_9j-0";
export var icon = "_9j-1";
export var text = "_9j-2";